
<div class="container">
  <iframe class="map"
    [src]="safeUrl"
    style="border: 0"
    allowfullscreen=""
    loading="lazy"    
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>

  <div class="info">
    <h1>{{ config().title }}</h1>
    <p>{{ config().subtitle }}</p>
    
    <table>
      @for(row of config().table?.rows; track row.index){        
        <tr>
          <td>{{row.columns[0].text}}</td>
          <td class="bold">{{row.columns[1].text}}</td>
        </tr>
      }        
    </table>

    @if(config().button){
    <a [href]="config().button?.link" mat-flat-button class="button">
        {{ config().button?.text }}
    </a>
    }
</div>
